import style from "./section-header.module.scss";

export default function SectionHeader({
  titleFields,
  text,
  options = [],
  wide = false,
}) {
  if (options === null) {
    return;
  }
  const hasTitle = options.includes("title");
  const hasSubtitle = options.includes("subtitle");
  const hasText = options.includes("text");

  const containerWide = wide ? "containerWide" : "";

  if (hasTitle || hasSubtitle || hasText) {
    return (
      <div className={`${style.container} ${style[containerWide]}`}>
        <div className={style.sectionHeader}>
          <div
            className={style.sectionTitle}
            style={{ textAlign: `${titleFields.titleOrientation}` }}
            data-reverse={titleFields.subtitleOverTitle}
          >
            {/* TODO:: Implement title tag */}
            {hasTitle && (
              <h2
                className={style.sectionTitle}
                style={{ color: `${titleFields.titlesColor}` }}
              >
                {titleFields.title}
              </h2>
            )}
            {hasSubtitle && (
              <h3
                className={style.sectionSubtitle}
                style={{ color: `${titleFields.titlesColor}` }}
              >
                {titleFields.subtitle}
              </h3>
            )}
          </div>

          {hasText && (
            <div
              className={style.sectionText}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          )}
        </div>
      </div>
    );
  } else {
    return null;
  }
}
